import "./CustomFileUploader.css";
import React, { useEffect, useRef, useState } from "react";
import { MdOutlineCloudUpload } from "react-icons/md";
import { MdDeleteForever } from "react-icons/md";
import apis from "../../utils/apis";
import httpAction from "../../utils/httpAction";

const MAX_SIZE = 4 * 1024 * 1024; // 4MB

const CustomFileUploader = ({ multiple = true, onChange, onEdit = [] }) => {
 
  const fileRef = useRef(null);
  const [error, setError] = useState(null);
  const [items, setItems] = useState(onEdit);
  const [success, setSuccess] = useState(null);



  // cleanup blob urls
  useEffect(() => {
    return () => {
      items.forEach((it) => {
        if (it.source === "blob") URL.revokeObjectURL(it.url);
      });
    };
  }, [items]);

useEffect(()=>{

  setItems(onEdit)
},[onEdit])

  const fileChange = async (e) => {
    const picked = Array.from(e.target.files || []);
    e.target.value = "";
    setError(null);

    if (!picked.length) return;

    const large = picked.filter((f) => f.size > MAX_SIZE);
    const small = picked.filter((f) => f.size <= MAX_SIZE);

    // add LARGE previews (not uploaded)
    if (large.length) {
      setError("Some images are larger than 1MB (they will not be uploaded).");

      const largeItems = large.map((f) => ({
        id: crypto.randomUUID?.() || `${f.name}-${Date.now()}`,
        url: URL.createObjectURL(f),
        error: true,
        source: "blob",
      }));

      setItems((prev) => (multiple ? [...prev, ...largeItems] : largeItems));
    }

    // upload SMALL only
    if (!small.length) return;

    const formData = new FormData();
    small.forEach((f) => formData.append("file", f));

    const data = {
      url: apis().uploadFile,
      method: "POST",
      formData,
    };

    const result = await httpAction(data);

    if (result?.status) {
      const serverItems = (result.file || []).map((path) => ({
        id: crypto.randomUUID?.() || `${path}-${Date.now()}`,
        url: path,
        error: null,
        source: "server",
      }));

      setItems((prev) => {
        const next = multiple
          ? [...prev, ...serverItems]
          : serverItems.slice(0, 1);
        onChange?.(next); // optional: give parent the full list
        return next;
      });
    }
  };

  const removeItem = (id) => {
    setItems((prev) => {
      const found = prev.find((x) => x.id === id);
      if (found?.source === "blob") URL.revokeObjectURL(found.url);

      const next = prev.filter((x) => x.id !== id);
      onChange?.(next);
      return next;
    });
  };

  useEffect(() => {
    const isLargeLeft = items?.filter((item) => item.error);
    if (!isLargeLeft?.length) {
      setError(null);
      setSuccess("all good");
    }
  }, [items]);

  return (
    <div>
      <input
        type="file"
        accept="image/*"
        onChange={fileChange}
        ref={fileRef}
        style={{ display: "none" }}
        multiple={multiple}
      />

      <div className="upload_box" onClick={() => fileRef.current?.click()}>
        <MdOutlineCloudUpload />
        <span className="upload_title">Upload Image</span>
        <span className="upload_des">Select png/jpg upto 1mb</span>
      </div>

      {error && <div className="upload_error">{error}</div>}
      {success && items?.length > 0 && !error && (
        <div className="upload_error upload_success">{success}</div>
      )}

      <div className="upload_previews">
        {items.map((it) => (
          <div
            className={`upload_preview ${it.error ? "isError" : ""}`}
            key={it.id}
          >
            <div className="upload_preview_image">
              <img
                src={it.source === "blob" ? it.url : apis().localUrl + it.url}
                alt=""
              />
            </div>

            <button
              type="button"
              className="upload_delete"
              onClick={() => removeItem(it.id)}
              title="Remove"
            >
              <MdDeleteForever />
            </button>

            {it.error && <div className="upload_badge">Too large</div>}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomFileUploader;
